import styled from 'styled-components';
import color from 'tinycolor2';

export const HeaderWrapper = styled.div`
  margin-top: 66px;
  display: flex;
  flex: none;
  flex-direction: column;
  align-items: center;
  padding: 0 30px;
  box-sizing: border-box;
`;

export const Title = styled.div`
  text-align: center;
  color: ${(props) => props.theme['modal.title.color']};
  line-height: 34px;
  font-size: 28px;
`;

export const TextWrapDescription = styled.div`
  margin-top: 15px;
  line-height: 22px;
  font-size: 16px;
  text-align: center;
  max-width: 566px;
  color: ${(props) => props.theme['modal.description.color']};
`;

export const BackButton = styled.button`
  position: fixed;
  top: 10px;
  left: 10px;
  height: 66px;
  width: 66px;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-evenly;
  padding-top: 5px;
  padding-bottom: 10px;
  outline: none;
  border: none;
  border-radius: 50%;
  transition: all 0.3s ease;
  background-color: ${(props) => props.theme['color.background']};

  letter-spacing: 1px;
  font-size: 12px;
  font-weight: bold;
  line-height: 14px;
  color: ${(props) => props.theme['color.text.light']};
  cursor: pointer;

  &:hover,
  &:active,
  &:focus {
    background-color: ${(props) => color(props.theme['color.text.body']).setAlpha(0.1).toString()};
  }

  &:focus {
    box-shadow: 0 0 0 3px ${(props) => color(props.theme['color.text.body']).setAlpha(0.3).toString()};
  }
`;
